<template>
  <page class="page-items">
    <sidebar slot="sidebar"/>
    <span slot="header">Items</span>
    <span slot="breadcrumbs">
      <b-breadcrumb :items="breadcrumbs"/>
      <router-link :to="{name: 'client-items'}">
        <i class="fas fa-exchange-alt"></i> Switch to Client View
      </router-link>
    </span>

    <div class="items-wrapper">
      <div class="item-actions">
        <b-button :disabled="saving || fetching" type="button" variant="secondary" @click="preview">
          Preview
        </b-button>
        <b-button :disabled="saving || fetching" type="button" variant="primary" @click="update">
          <span v-if="saving"><i class="fas fa-spinner fa-spin"></i></span>
          Save
        </b-button>
      </div>

      <b-container fluid class="item-alerts">
        <b-row>
          <b-col cols="12" xl="8" offset-xl="2">
            <span v-if="hasApiErrors">
              <b-alert show variant="danger" class="text-center">
                There was an issue saving. Please correct the error(s) below.
              </b-alert>
            </span>
          </b-col>
          <b-col cols="12">
            <span v-if="fetching">
              <i class="fas fa-spinner fa-spin"></i>
              Loading...
            </span>
          </b-col>
        </b-row>
      </b-container>

      <template v-if="items.length">
        <template v-for="item in items">
          <item-add :key="item.id + 1" :next-id="item.id" />
          <row :key="item.id" :id="item.id"/>
        </template>
        <item-add/>
      </template>

      <!-- singletons -->
      <move-modal :items="items" />

      <template v-if="!items.length && !fetching">
        <empty-topic/>
      </template>
    </div>

  </page>
</template>

<script>
import { mapState, mapGetters, mapActions } from 'vuex'
import page from '../../../templates/page'
import sidebar from '../../../sidebar'
import emptyTopic from './empty-topic'
import row from './row'
import itemAdd from './add'
import moveModal from './move'

export default {
  components: {
    sidebar,
    page,
    emptyTopic,
    row,
    itemAdd,
    moveModal
  },
  data() {
    return {
      breadcrumbs: [{
        text: 'Modules',
        to: {
          name: 'admin-modules'
        }
      },
      {
        text: 'Components',
        to: {
          name: 'admin-components'
        }
      },
      {
        text: 'Topics',
        to: {
          name: 'admin-topics'
        }
      },
      {
        text: 'Items',
        active: true
      }]
    }
  },
  computed: {
    ...mapState('tenants', {
      organization: 'current'
    }),
    ...mapState('modules', {
      module: 'current'
    }),
    ...mapState('components', {
      component: 'current'
    }),
    ...mapState('topics', {
      topic: 'current'
    }),
    ...mapState('items', {
      saving: 'saving',
      fetching: 'fetching',
      hasApiErrors: 'hasApiErrors',
      modals: 'modals'
    }),
    ...mapGetters('items', {
      items: 'editing'
    }),
    ...mapGetters('items', {
      moveModal: 'moveModal'
    })
  },
  watch: {
    hasApiErrors: function (newState, oldState) {
      if (oldState === false && newState === true) {
        window.scrollTo(0, 0)
      }
    }
  },
  created () {
    this.$store.commit('items/setHasApiErrors', false)
  },
  methods: {
    ...mapActions({
      updateItems: 'items/update'
    }),
    update () {
      this.updateItems()
    },
    preview () {
      this.$router.push({
        name: 'client-items',
        query: {
          preview: true,
          dontFetch: true
        }
      })
    }
  }
}
</script>

<style lang="scss">
@import 'assets/stylesheets/main.scss';
.page-items {
  .items-wrapper {
    padding-left: $spacing-sm;
    padding-right: $spacing-sm;

    .item-alerts {
      height: $spacing-lg;
    }

    .item-actions {
      position: fixed;
      right: 100px;
      padding: 0.5rem;
      box-shadow: none;
      border: 1px dashed $brand-dark-primary;
      border-radius: 5px;
      z-index: 1029;
      background: $light-secondary;
    }

    .item-error {
      >.item-card {
        box-shadow: 0 0 10px rgba(255, 0, 0, 0.6);
        border-color: red;
      }
    }

    .item-card {
      border: 1px solid $brand-dark-primary;

      .item-card {
        border: 1px solid $light-grey;
      }

    }

    h2 {
      font-size: 18px;
      margin-bottom: $spacing-xs;
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/pages/admin/items/index.vue